import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import "./style.scss";
import SuccessModal from "./SuccessModal";
import { getWebinarDetail, knowledgestackRegister } from "../actions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { formDataGenerator } from "../../../../../utils/common";
import { Helmet } from "react-helmet";

const WebinarDetail = (props) => {

  const {
    getWebinarDetail, 
    webDetailData,
    knowledgestackRegister,
    knowledgeWebinarRegister,
    location: { pathname }
  } = props;

  const sugUrl = pathname.split("/")[4] ? pathname.split("/")[4] : "";
  const [webinardetail, setWebinardeail] = useState();
  const [featuredspeaker, setFeaturedspeaker] = useState();
  const [nodeId, setNodeId] = useState();
  const [metaData, setMetaData] = useState();
  const [webinarId, setWebinarId] = useState();
  const [formfield, setFormfield] = useState();
  const [dynamicIntialValue, setDynamicIntialValue] = useState();

  useEffect(() => {
    getWebinarDetail({},sugUrl);
  }, [sugUrl]);

  useEffect(() => {
    if (webDetailData) {
      setWebinardeail(webDetailData);
    }
    if (webDetailData && webDetailData.featuredspeakers) {
      setFeaturedspeaker(webDetailData.featuredspeakers);
    }
    if (webDetailData && webDetailData.node_id) {
      setNodeId(webDetailData.node_id);
    }
    if (webDetailData && webDetailData.webinarId) {
      setWebinarId(webDetailData.webinarId);
    }
    if (webDetailData && webDetailData.meta) {
      setMetaData(webDetailData.meta);
    }
    if (webDetailData && webDetailData.webinarQuestions) {
      setFormfield(webDetailData.webinarQuestions);
    }
  }, [webDetailData]);

  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [email, setEmail] = useState();
  const [mobile, setMobile] = useState();
  const [successModalShow, setSuccessModalShow] = useState(false);
  const handleSuccessModal = () => setSuccessModalShow(false);
  const [dynamicValidation, setDynamicValidation] = useState();
  const [registerflag, setRegisterflag] = useState(false);

  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
  const firstlastRegExp = /^[A-Za-z]+$/;
  const validationSchema = Yup.object().shape({});

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      city: "",
      ...dynamicIntialValue,
    },
    validationSchema: formfield && formfield.custom_questions ? dynamicValidation: validationSchema,

    onSubmit: (data) => {
      setRegisterflag(true);
      let payload = {
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        city: data.city,
        custom_questions: [],
        nodeId: nodeId,
        webinarId: webinarId,
      };
      if (formfield && formfield.custom_questions) {
        formfield.custom_questions.forEach((question) => {
          payload.custom_questions.push({
            title: question.title,
            value: data[question.title.replace(/\./g, "")], 
          });
        });
      }
      payload.custom_questions = JSON.stringify(payload.custom_questions);
      knowledgestackRegister(formDataGenerator(payload));
    },
  });

  const generateDynamicSchema = (customQuestions) => {
    const dynamicSchema = {
      firstName: Yup.string()
      .matches(firstlastRegExp, "Please enter your first name")
      .required("Please enter your first name"),
    lastName: Yup.string()
      .matches(firstlastRegExp, "Please enter your last name")
      .required("Please enter your last name"),
    email: Yup.string()
      .email("Email is not correct")
      .required("Please enter your email address"),
    city: Yup.string()  
      .matches(firstlastRegExp, "Please enter your city name")
      .required("Please enter your city name"), 
    };

    if (customQuestions && Array.isArray(customQuestions)) {
      customQuestions.forEach((data) => {
        if (data.type === 'short' && data.required) {
          dynamicSchema[data.title.replace(/\./g, "")] = Yup.string().required(`${data.title} is required`);
        } else if (data.type === 'single_radio' && data.required) {
          dynamicSchema[data.title.replace(/\./g, "")] = Yup.string().required(`${data.title} is required`);
        } else if (data.type === 'single_dropdown' && data.required) {
          dynamicSchema[data.title.replace(/\./g, "")] = Yup.string().required(`Please select ${data.title} configuration`);
        }
      });
    }
    return Yup.object().shape(dynamicSchema);
  };

  const generateDynamicInitialValues = (customQuestions) => {
    const dynamicInitialValues = {};
  
    if (customQuestions && Array.isArray(customQuestions)) {
      customQuestions.forEach((data) => {
        dynamicInitialValues[data.title.replace(/\./g, "")] = ''; 
      });
    }
    setDynamicIntialValue(dynamicInitialValues);
    return dynamicInitialValues;
  };

  useEffect(() => {
    if (formik.values.firstName) {
      setFirstName(formik.values.firstName);
    }
  }, [formik.values.firstName]);
  useEffect(() => {
    if (formik.values.lastName) {
      setLastName(formik.values.lastName);
    }
  }, [formik.values.lastName]);
  useEffect(() => {
    if (formik.values.email) {
      setEmail(formik.values.email);
    }
  }, [formik.values.email]);
  useEffect(() => {
    if (formik.values.mobile) {
      setMobile(formik.values.mobile);
    }
  }, [formik.values.mobile]);

  useEffect(() => {
    if (knowledgeWebinarRegister && knowledgeWebinarRegister.webinarRegistration) {
      setSuccessModalShow(true);
      setRegisterflag(false);
      formik.resetForm();
      Object.keys(formik.values).forEach(field => {
        formik.setFieldValue(field, '');
      });
    }
  }, [knowledgeWebinarRegister]);

  useEffect(()=>{
    if(formfield){
      formfield && formfield.custom_questions && setDynamicValidation(generateDynamicSchema(formfield.custom_questions));
      formfield && formfield.custom_questions &&
      formik.setValues({
        ...formik.values,
        ...generateDynamicInitialValues(formfield.custom_questions),
      });
    }
  },[formfield]);

  return (
    <div className="wrapper">
      {
        metaData ? (
          <Helmet>
            <title>{metaData && metaData.title ? metaData.title : ""}</title>
              <meta name="description"
                content={
                  metaData && metaData.description ? metaData.description : ""
                }
              />
              <meta name="keywords"
                content={
                  metaData && metaData.keywords ? metaData.keywords : ""
                }
              />
              <meta property="og:title"
                content={
                  metaData && metaData.og_title ? metaData.og_title : ""
                }
              />
              <meta property="og:description"
                content={
                  metaData && metaData.og_description ? metaData.og_description : ""
                }
              />
              <meta property="og:image"
                content={
                  metaData && metaData.og_image ? metaData.og_image : ""
                }
              />
              <meta property="og:url"
                content={
                  metaData && metaData.og_url ? metaData.og_url : ""
                }
              />
          </Helmet>
        ) : ("")
      }
      <section className="aboutHead">
        <div className="container">
          <div className="d-flex">
            <h1 className="me-auto">
              <span>Webinars</span>
            </h1>
            <nav
              aria-label="breadcrumb"
              className="align-self-center breadCrumbCust d-md-inlin"
            >
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li className="breadcrumb-item">
                  <a href="/knowledge-stack">Knowledge Stack</a>
                </li>
                <li
                  className="breadcrumb-item active breadcolor"
                  aria-current="page"
                >
                  <a href="/knowledge-stack/interactive-media/webinar">Webinar</a>
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </section>

      <section>
        <div className="container mt-4">
          <div className="mb-3">
            <img
              src={webinardetail && webinardetail.promotional_banner}
              className="img-fluid"
            />
          </div>

          <div className="webinardetail my-3">
            <div className="row">
              <div className="col-lg-8">
                <div>
                  <h3 className="detailhead my-2">{webinardetail && webinardetail.title ? webinardetail.title : ""}</h3>
                  <div className="timedetail my-2">
                    <span className="date">{webinardetail && webinardetail.webinar_date ? webinardetail.webinar_date : ""}</span>
                  </div>
                  {
                    webinardetail && webinardetail.body ? <div dangerouslySetInnerHTML={{__html: webinardetail.body }} /> : null
                  }
                  
                </div>

                <div className="featuredspeaker mt-4">
                  <p className="headtext mb-3">Featured Speakers</p>

                  {
                    featuredspeaker &&
                    featuredspeaker.length > 0 &&
                    featuredspeaker.map((item, index) => (
                      <div className="d-flex mb-3">
                        <img
                          src={item.profileUrl ? item.profileUrl : ""}
                          className="my-2 my-md-0"
                        />
                        <div className="d-flex align-items-center ms-3">
                          <div>
                            <h3 className="speakername">{item.managerName ? item.managerName : ""}</h3>
                            {item.information ? <div dangerouslySetInnerHTML={{__html: item.information}} /> : ""}
                          </div>
                        </div>
                      </div>
                    ))
                  }
                </div>
              </div>
              <div className="col-lg-4 my-4 my-md-2">
                <div className="register p-4">
                  <p className="mb-4 headtext text-center">
                    Register for Webinar
                  </p>

                  <form onSubmit={formik.handleSubmit}>
                    <input
                      type="text"
                      placeholder="First Name*"
                      name="firstName"
                      onChange={formik.handleChange}
                      value={formik.values.firstName}
                      className={
                        "mt-3 form-control form-control-lg" +
                        (formik.errors.firstName && formik.touched.firstName
                          ? " is-invalid"
                          : "")
                      }
                    />
                    <div className="invalid-feedback">
                      {formik.errors.firstName && formik.touched.firstName
                        ? formik.errors.firstName
                        : null}
                    </div>
                    <input
                      type="text"
                      placeholder="Last Name*"
                      name="lastName"
                      onChange={formik.handleChange}
                      value={formik.values.lastName}
                      className={
                        "mt-3 form-control form-control-lg" +
                        (formik.errors.lastName && formik.touched.lastName
                          ? " is-invalid"
                          : "")
                      }
                    />
                    <div className="invalid-feedback">
                      {formik.errors.lastName && formik.touched.lastName
                        ? formik.errors.lastName
                        : null}
                    </div>
                    <input
                      type="text"
                      placeholder="Email*"
                      name="email"
                      onChange={formik.handleChange}
                      value={formik.values.email}
                      className={
                        "mt-3 form-control form-control-lg" +
                        (formik.errors.email && formik.touched.email
                          ? " is-invalid"
                          : "")
                      }
                    />
                    <div className="invalid-feedback">
                      {formik.errors.email && formik.touched.email
                        ? formik.errors.email
                        : null}
                    </div>
                    <input
                      type="text"
                      placeholder="City*"
                      name="city"
                      onChange={formik.handleChange}
                      value={formik.values.city}
                      className={
                        "mt-3 form-control form-control-lg" +
                        (formik.errors.city && formik.touched.city
                          ? " is-invalid"
                          : "")
                      }
                    />
                    <div className="invalid-feedback">
                      {formik.errors.city && formik.touched.city
                        ? formik.errors.city
                        : null}
                    </div>
                    {formfield && formfield.custom_questions && formfield.custom_questions.map((data, index) => {
                      return (
                        <>
                          {data && data.type === "short" && (
                            <div key={index}>
                              <input
                                type="text"
                                placeholder={`${data.title}${data.required ? "*" : ""}`}
                                name={data.title.replace(/\./g, "")}
                                onChange={formik.handleChange}
                                value={formik.values[data.title.replace(/\./g, "")]}
                                className={
                                  "mt-3 form-control form-control-lg" +
                                  (formik.errors[data.title.replace(/\./g, "")] && formik.touched[data.title.replace(/\./g, "")] && data.required
                                    ? " is-invalid"
                                    : "")
                                }
                              />
                              <div className="invalid-feedback">
                                {formik.errors[data.title.replace(/\./g, "")] && formik.touched[data.title.replace(/\./g, "")] && data.required
                                  ? formik.errors[data.title.replace(/\./g, "")]
                                  : null}
                              </div>
                            </div>
                          )}
                          {data && data.type == "single_radio" && (
                            <div>
                              <div className="label">
                                <label htmlFor={data.title.replace(/\./g, "")} className="mt-3">{`${data.title}${data.required ? "*" : ""}`}</label>
                              </div>
                              {data.answers && data.answers.map((option, optionIndex) => (
                                <div className="d-flex" key={optionIndex}>
                                  <div className="justify-content-center align-items-center input">
                                    <input
                                      type="radio"
                                      name={data.title.replace(/\./g, "")}
                                      value={option}
                                      onChange={formik.handleChange}
                                      checked={formik.values[data.title.replace(/\./g, "")] === option}
                                    />
                                  </div>
                                  <div className="label2">
                                    <label htmlFor={`${option}`} className="form-check-label">
                                      {option}
                                    </label>
                                  </div>
                                </div>
                              ))}
                              <div className={formik.errors[data.title.replace(/\./g, "")] && formik.touched[data.title.replace(/\./g, "")] && data.required
                                  ? "invalid-error"
                                  : ""}>
                                {formik.errors[data.title.replace(/\./g, "")] && formik.touched[data.title.replace(/\./g, "")] && data.required
                                  ? formik.errors[data.title.replace(/\./g, "")]
                                  : null}
                              </div>
                            </div>
                          )}
                          {data && data.type == "single_dropdown" && (
                            <div key={index}>
                              <div className="mt-3">
                                <select 
                                  className={
                                    "form-select ipgroup" +
                                    (formik.errors[data.title.replace(/\./g, "")] && formik.touched[data.title.replace(/\./g, "")] && data.required
                                      ? " invalid-select"
                                      : "")
                                  } 
                                  name={data.title.replace(/\./g, "")} 
                                  id="GroupSelect"
                                  onChange={formik.handleChange}
                                  value={formik.values[data.title.replace(/\./g, "")]}
                                >
                                  <option value={""} disabled selected hidden>{data.required ? `${data.title}*` : data.title}</option>
                                  {
                                    data && data.answers &&
                                    data.answers.map((item,index) => (
                                      <option key={index} value={item}>{item}</option>
                                    ))
                                  }
                                </select>
                              </div>
                              <div className={formik.errors[data.title.replace(/\./g, "")] && formik.touched[data.title.replace(/\./g, "")] && data.required
                                  ? "invalid-error"
                                  : ""}>
                                {formik.errors[data.title.replace(/\./g, "")] && formik.touched[data.title.replace(/\./g, "")] && data.required
                                  ? formik.errors[data.title.replace(/\./g, "")]
                                  : null}
                              </div>
                            </div>
                          )}
                        </>
                      );
                    })}
                    <button
                      type="submit"
                      className="d-flex mx-auto mt-3 btn btn-primary"
                      disabled={registerflag}
                    >
                      Register
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <SuccessModal open={successModalShow} onClose={handleSuccessModal} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  webDetailData: state.KnowledgeStack.webDetailPageData,
  knowledgeWebinarRegister: state.KnowledgeStack,
});

const mapDispatchToProps = (dispatch) => ({
  getWebinarDetail: bindActionCreators(getWebinarDetail, dispatch),
  knowledgestackRegister: bindActionCreators(knowledgestackRegister, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(WebinarDetail);
